import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=9ea40744&"
import script from "./HomeView.vue?vue&type=script&lang=js&"
export * from "./HomeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ea40744')) {
      api.createRecord('9ea40744', component.options)
    } else {
      api.reload('9ea40744', component.options)
    }
    module.hot.accept("./HomeView.vue?vue&type=template&id=9ea40744&", function () {
      api.rerender('9ea40744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/HomeView.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeView.vue
// module id = 509
// module chunks = 0